export default {
  example: {
    id: 'product_page_customization_example_image',
    defaultMessage: 'Example image',
  },
}
